module.exports = __webpack_public_path__ + "static/aboutBg-00c8d8573dac1dc68628ec971fdc5884.jpg";